import { CameraEventType, KeyboardEventModifier } from "cesium";
import { ControlsPreset } from "./ControlsPreset";

export const CESIUM_CONTROLS_PRESET: ControlsPreset = {
  key: "cesium",
  group: "default",
  display: {
    title: "Cesium",
    subtitle: "Universal spatial controls",
    description:
      "Designed for easy navigation of BIM, GIS, and point cloud models while providing compatibility with a variety of datasets.",
  },
  mappings: {
    pan: {
      display: {
        title: "Pan",
        instructions: "Left click",
      },
      cesiumInputs: [{ eventType: CameraEventType.LEFT_DRAG }],
    },
    orbitAroundPoint: {
      display: {
        title: "Orbit Around Point",
        instructions: "Middle click",
      },
      cesiumInputs: [
        { eventType: CameraEventType.MIDDLE_DRAG },
        { eventType: CameraEventType.PINCH },
        {
          eventType: CameraEventType.LEFT_DRAG,
          modifier: KeyboardEventModifier.CTRL,
        },
        {
          eventType: CameraEventType.RIGHT_DRAG,
          modifier: KeyboardEventModifier.CTRL,
        },
      ],
    },
    lookAround: {
      display: {
        title: "Look Around",
        instructions: ["Shift", "Left click"],
      },
      cesiumInputs: [
        {
          eventType: CameraEventType.LEFT_DRAG,
          modifier: KeyboardEventModifier.SHIFT,
        },
        {
          eventType: CameraEventType.LEFT_DRAG,
          modifier: KeyboardEventModifier.ALT,
        },
      ],
    },
    zoom: {
      cesiumInputs: [
        { eventType: CameraEventType.RIGHT_DRAG },
        { eventType: CameraEventType.WHEEL },
        { eventType: CameraEventType.PINCH },
      ],
    },
  },
};
